/* ==========================================================================
   FX PRODUCT — adaptado del prototipo aprobado
   C:\Shopify\hero-anterior-original\prototype-future-store\app.js
   Módulos portados: gallery (thumbnails + flechas), quantity stepper,
   acordeón de ficha técnica (mismo patrón que faqModule).
   Módulo nuevo (no existe en el prototipo): variant matcher — necesario
   porque el prototipo no maneja variantes reales de Shopify.
   ========================================================================== */
(function () {
  "use strict";

  /* ------------------------------------------------------------------
     1. GALLERY — miniaturas + flechas prev/next
  ------------------------------------------------------------------ */
  (function fxProductGalleryModule() {
    const slides = document.querySelectorAll("[data-fx-gallery-slide]");
    const thumbs = document.querySelectorAll("[data-fx-gallery-thumb]");
    const prevBtn = document.querySelector("[data-fx-gallery-prev]");
    const nextBtn = document.querySelector("[data-fx-gallery-next]");
    if (!slides.length) return;

    const slideList = Array.from(slides);
    const thumbList = Array.from(thumbs);
    let activeIndex = slideList.findIndex((s) => s.classList.contains("fx-is-active"));
    if (activeIndex < 0) activeIndex = 0;

    function pauseSlideMedia(slide) {
      const deferred = slide.querySelector("deferred-media");
      if (deferred && typeof deferred.pauseMedia === "function") {
        deferred.pauseMedia();
        return;
      }
      const video = slide.querySelector("video");
      if (video && !video.paused) video.pause();
    }

    slideList.forEach((s, i) => {
      s.classList.toggle("fx-is-active", i === activeIndex);
      if (i !== activeIndex) pauseSlideMedia(s);
    });
    thumbList.forEach((t, i) => t.classList.toggle("fx-is-active", i === activeIndex));

    function setActive(index) {
      const nextIndex = ((index % slideList.length) + slideList.length) % slideList.length;
      if (nextIndex === activeIndex) return;
      pauseSlideMedia(slideList[activeIndex]);
      activeIndex = nextIndex;
      slideList.forEach((s, i) => s.classList.toggle("fx-is-active", i === activeIndex));
      thumbList.forEach((t, i) => t.classList.toggle("fx-is-active", i === activeIndex));
    }

    thumbList.forEach((thumb, i) => {
      thumb.addEventListener("click", () => setActive(i));
    });
    if (prevBtn) prevBtn.addEventListener("click", () => setActive(activeIndex - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => setActive(activeIndex + 1));

    window.fxSetGalleryImageByMediaId = function (mediaId) {
      const index = slideList.findIndex((s) => s.getAttribute("data-media-id") === String(mediaId));
      if (index >= 0) setActive(index);
    };
  })();

  /* ------------------------------------------------------------------
     2. QUANTITY STEPPER
  ------------------------------------------------------------------ */
  (function fxProductQtyModule() {
    const qtyControl = document.querySelector("[data-fx-qty-control]");
    const qtyValueEl = qtyControl ? qtyControl.querySelector("[data-fx-qty-value]") : null;
    const qtyInput = document.querySelector("[data-fx-qty-input]");
    const decreaseBtn = qtyControl ? qtyControl.querySelector("[data-fx-qty-decrease]") : null;
    const increaseBtn = qtyControl ? qtyControl.querySelector("[data-fx-qty-increase]") : null;
    if (!qtyValueEl) return;

    const MIN_QTY = 1;
    const MAX_QTY = 99;

    function getQty() {
      const n = parseInt(qtyValueEl.textContent, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    }

    function setQty(n) {
      const clamped = Math.min(MAX_QTY, Math.max(MIN_QTY, n));
      qtyValueEl.textContent = String(clamped);
      if (qtyInput) qtyInput.value = String(clamped);
    }

    if (decreaseBtn) decreaseBtn.addEventListener("click", () => setQty(getQty() - 1));
    if (increaseBtn) increaseBtn.addEventListener("click", () => setQty(getQty() + 1));
  })();

  /* ------------------------------------------------------------------
     3. ACORDEÓN DE FICHA TÉCNICA (mismo patrón que faqModule del prototipo)
  ------------------------------------------------------------------ */
  (function fxProductDetailsAccordionModule() {
    document.querySelectorAll(".fx-faq-question").forEach((btn) => {
      btn.addEventListener("click", () => {
        const isOpen = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!isOpen));
      });
    });
  })();

  /* ------------------------------------------------------------------
     4. VARIANT MATCHER (nuevo — no existe en el prototipo)
     Empareja las opciones seleccionadas contra product.variants (JSON
     real de Shopify) y actualiza precio, disponibilidad, id de variante
     e imagen. Defensivo: si no hay selector de variantes en la página
     (producto de variante única), no hace nada.
  ------------------------------------------------------------------ */
  (function fxVariantMatcherModule() {
    const root = document.querySelector("[data-fx-product-form]");
    if (!root) return;

    const variantsJson = root.getAttribute("data-variants");
    if (!variantsJson) return;

    let variants;
    try {
      variants = JSON.parse(variantsJson);
    } catch (e) {
      return;
    }

    const optionGroups = Array.from(root.querySelectorAll("[data-fx-option-index]"));
    const variantIdInput = root.querySelector("[data-fx-variant-id]");
    const addButton = root.querySelector("[data-fx-add-to-cart]");
    const soldOutButton = root.querySelector("[data-fx-sold-out]");
    const buyNowWrap = root.querySelector("[data-fx-buy-now]");
    const priceCurrent = document.querySelector("[data-fx-price-current]");
    const priceOld = document.querySelector("[data-fx-price-old]");
    const discountBadge = document.querySelector("[data-fx-discount-badge]");
    const stickyPrice = document.querySelector("[data-fx-sticky-price]");

    function money(cents) {
      return (cents / 100).toLocaleString("es-MX", { style: "currency", currency: "MXN" });
    }

    function getSelectedOptions() {
      return optionGroups.map((group) => {
        const selected = group.querySelector(".fx-is-selected");
        return selected ? selected.getAttribute("data-fx-option-value") : null;
      });
    }

    function findMatchingVariant(selected) {
      return variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3];
        return selected.every((val, i) => val === null || opts[i] === val);
      });
    }

    function updateAvailability(selected) {
      optionGroups.forEach((group, groupIndex) => {
        const buttons = group.querySelectorAll("[data-fx-option-value]");
        buttons.forEach((button) => {
          const testValues = selected.slice();
          testValues[groupIndex] = button.getAttribute("data-fx-option-value");
          const match = findMatchingVariant(testValues);
          button.classList.toggle("fx-is-unavailable", !match || !match.available);
        });
      });
    }

    function applyVariant(variant) {
      if (!root) return;

      if (variant) {
        if (variantIdInput) variantIdInput.value = variant.id;

        if (priceCurrent) priceCurrent.textContent = money(variant.price);
        if (stickyPrice) stickyPrice.textContent = money(variant.price);

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (priceOld) {
          if (onSale) {
            priceOld.textContent = money(variant.compare_at_price);
            priceOld.hidden = false;
          } else {
            priceOld.hidden = true;
          }
        }
        if (discountBadge) {
          if (onSale) {
            const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            discountBadge.textContent = `-${pct}%`;
            discountBadge.hidden = false;
          } else {
            discountBadge.hidden = true;
          }
        }

        if (addButton) addButton.hidden = !variant.available;
        if (soldOutButton) soldOutButton.hidden = variant.available;
        if (buyNowWrap) buyNowWrap.hidden = !variant.available;

        if (variant.featured_media && window.fxSetGalleryImageByMediaId) {
          window.fxSetGalleryImageByMediaId(variant.featured_media.id);
        }
      } else {
        if (addButton) addButton.hidden = true;
        if (soldOutButton) soldOutButton.hidden = false;
        if (buyNowWrap) buyNowWrap.hidden = true;
      }
    }

    optionGroups.forEach((group, groupIndex) => {
      group.querySelectorAll("[data-fx-option-value]").forEach((button) => {
        button.addEventListener("click", () => {
          group.querySelectorAll("[data-fx-option-value]").forEach((b) => b.classList.remove("fx-is-selected"));
          button.classList.add("fx-is-selected");

          const selected = getSelectedOptions();
          updateAvailability(selected);
          applyVariant(findMatchingVariant(selected));
        });
      });
    });

    updateAvailability(getSelectedOptions());
  })();

  /* ------------------------------------------------------------------
     5. RATING LINK — scroll suave real al bloque de reseñas sin recargar
  ------------------------------------------------------------------ */
  (function fxRatingScrollModule() {
    const link = document.querySelector(".fx-product-rating-link");
    if (!link) return;

    link.addEventListener("click", (event) => {
      const target = document.querySelector("#fx-product-reviews");
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });

      if (history.pushState) {
        history.pushState(null, "", "#fx-product-reviews");
      } else {
        history.replaceState(null, "", "#fx-product-reviews");
      }
    });
  })();
})();
